/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_5_AInputs */

const en_mk_faq_5_a = /** @type {(inputs: Mk_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks have acceptance criteria and check evidence. Your execution mode controls when approval is required. Overriding a check requires a recorded reason. Evidence helps you review results; test the app for your needs before release.`)
};

const id_mk_faq_5_a = /** @type {(inputs: Mk_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugas memiliki kriteria penerimaan dan bukti pemeriksaan. Mode eksekusi menentukan kapan persetujuanmu diperlukan. Melewati pemeriksaan memerlukan alasan yang tercatat. Bukti membantu meninjau hasil; tetap uji aplikasi sesuai kebutuhan sebelum rilis.`)
};

/**
* | output |
* | --- |
* | "Tasks have acceptance criteria and check evidence. Your execution mode controls when approval is required. Overriding a check requires a recorded reason. Evi..." |
*
* @param {Mk_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_5_a = /** @type {((inputs?: Mk_Faq_5_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_5_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_5_a(inputs)
	return en_mk_faq_5_a(inputs)
});